import React from "react";
import VehicleListItem from "./vehicleItemList";
import "./vehicleSidebar.css";

const VehicleSidebar = ({ vehicles, selectedVehicle, onVehicleSelect }) => {
  return (
    <div className="vehicle-sidebar">
      <div className="sidebar-header">
        <h3>Vehicles ({vehicles.length})</h3>
      </div>

      <div className="vehicle-list">
        {vehicles.length === 0 ? (
          <div className="no-vehicles">
            <p>No vehicles found</p>
          </div>
        ) : (
          vehicles.map((vehicle) => (
            <VehicleListItem
              key={vehicle.vehicleregnumber}
              vehicle={vehicle}
              isSelected={
                selectedVehicle &&
                selectedVehicle.vehicleregnumber === vehicle.vehicleregnumber
              }
              onSelect={() => onVehicleSelect(vehicle)}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default VehicleSidebar;